var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1D2445;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.2,19.6c0-2.7,0.6-5.3,1.7-7.7s2.8-4.5,4.9-6.2l2.1,2.2c-1.8,1.4-3.1,3.2-4.1,5.2s-1.5,4.2-1.5,6.4H6.2z  M38.9,19.6c0-2.3-0.5-4.4-1.4-6.4s-2.3-3.7-4-5.2l2-2.2c2.1,1.7,3.7,3.8,4.8,6.2c1.1,2.4,1.7,4.9,1.7,7.6H38.9z M8,38v-3h4.2V19.7 c0-2.8,0.8-5.3,2.5-7.5s3.8-3.6,6.5-4.1V6.7c0-0.8,0.3-1.4,0.8-1.9S23.2,4,24,4c0.8,0,1.4,0.2,2,0.8c0.6,0.5,0.8,1.1,0.8,1.9v1.5 c2.7,0.6,4.9,1.9,6.6,4.1c1.7,2.2,2.5,4.7,2.5,7.5V35H40v3H8z M24,44c-1.1,0-2-0.4-2.8-1.2C20.4,42,20,41.1,20,40h8 c0,1.1-0.4,2-1.2,2.8C26,43.6,25.1,44,24,44z M15.2,35h17.6V19.7c0-2.5-0.8-4.6-2.5-6.3c-1.7-1.7-3.8-2.6-6.2-2.6 c-2.5,0-4.6,0.9-6.3,2.6s-2.6,3.8-2.6,6.3V35z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.73e5b2207eafea0381392e633057199b.svg";
export { ForwardRef as ReactComponent };